<div class="alert-box" [ngClass]="type()">
  <div class="alert-content">
    <div class="icon">
      @switch (type()) {
        @case (alertType.info) {
          <mat-icon>info</mat-icon>
        }
        @case (alertType.error) {
          <mat-icon>cancel</mat-icon>
        }
        @case (alertType.warn) {
          <mat-icon>help</mat-icon>
        }
        @case (alertType.success) {
          <mat-icon>check_circle</mat-icon>
        }
      }
    </div>
    <div class="content" [ngClass]="type()">
      <ng-content></ng-content>
    </div>
  </div>
  @if (withCloseIcon()) {
    <button mat-icon-button class="close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
